import React, { useEffect, useMemo } from 'react'
import { string, shape, object, func, bool } from 'prop-types'
import { Form, Select } from 'antd'
import { getCnaeField } from '~/states/modules/cnaeField'
import { useDispatch, useSelector } from 'react-redux'
import InfoField from '~/components/infoField'
import { filterText } from '~/services/filter'
import { useFocusCallback } from 'utils/fieldHooks'

const CnaeField = ({
	pageFieldsData,
	className,
	onChange,
	onFocus,
	inputValue,
	disabled,
	visible,
}) => {
	const { label, variable, type, id, info, list, optional } = pageFieldsData
	const isObj = typeof variable === 'object'
	const varname = isObj ? variable.name : variable
	const name = id !== undefined ? `${varname}_${id}` : varname

	const dispatch = useDispatch()
	const { data } = useSelector(({ cnaeField }) => cnaeField)

	useEffect(() => {
		if (!data) dispatch(getCnaeField())
	}, [dispatch, data])

	const cnaeDescription = useMemo(
		() => data?.map((cnae) => cnae.descricao) ?? [],
		[data]
	)

	const focusCallback = useFocusCallback(onFocus, pageFieldsData)

	return (
		<Form.Item
			key={name}
			name={list !== undefined ? [list, name] : name}
			label={<InfoField label={label} info={info} />}
			hasFeedback
			className={className}
			rules={
				visible && [
					{ required: !optional, message: 'Este campo é obrigatório.' },
				]
			}
			type={type}
			colon={false}
			initialValue={!inputValue ? '' : inputValue}>
			<Select
				showSearch={true}
				disabled={disabled}
				filterOption={filterText}
				onChange={onChange ? (v) => onChange(v) : undefined}
				onFocus={focusCallback}>
				{cnaeDescription.map((option, index) => (
					<Select.Option key={index} value={option}>
						{option}
					</Select.Option>
				))}
			</Select>
		</Form.Item>
	)
}

CnaeField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: object.isRequired,
		type: string.isRequired,
		info: string,
	}).isRequired,
	className: string,
	onChange: func,
	onFocus: func,
	inputValue: string,
	disabled: bool,
	visible: bool,
}

CnaeField.defaultProps = {
	onChange: () => {},
	onFocus: () => {},
	visible: true,
}

export default CnaeField
